// extracted by mini-css-extract-plugin
export default {"chatMessageContent":"Message_chatMessageContent__hrhiA"};